import React, { FocusEvent, ReactNode } from 'react';
import { FetchingLabel, InputBox, Input, ClearButton } from './styles';
import { CircularProgress } from '@material-ui/core';
import Close from '@material-ui/icons/Close';
import { UseFormRegisterReturn } from 'react-hook-form';

type Props = {
  value: string;
  onValueChange: (newValue: string) => void;
  className?: string;
  isSearchingByUser: boolean;
  onFocus: (event: FocusEvent<HTMLInputElement>) => void;
  onClear: () => void;
  ErrorMessage: ReactNode | undefined;
  hiddenClearButton: boolean;
  placeholder: string;
  registerInput: () => UseFormRegisterReturn;
};

export default function CellphoneInput({
  value,
  onValueChange,
  className,
  onFocus,
  isSearchingByUser,
  ErrorMessage,
  hiddenClearButton,
  placeholder,
  onClear,
  registerInput,
}: Props) {
  const { ref } = registerInput();

  return (
    <>
      <InputBox className={className}>
        <Input
          inputRef={ref}
          type="tel"
          value={value}
          onAccept={(value) => onValueChange(value)}
          placeholder={placeholder}
          unmask
          mask={[{ mask: '(00) 0000-0000' }, { mask: '(00) 00000-0000' }]}
          onFocus={onFocus}
          dataCy="user-informations-cellphone-input"
          autoComplete="no"
        />
        {!hiddenClearButton && (
          <ClearButton onClick={onClear}>
            <Close />
          </ClearButton>
        )}
      </InputBox>
      {isSearchingByUser && <Fetching label="Buscando dados do cliente..." />}
      {ErrorMessage && ErrorMessage}
    </>
  );
}

type FetchingProps = {
  label: string;
};

function Fetching({ label }: FetchingProps) {
  return (
    <FetchingLabel>
      <CircularProgress size={12} style={{ color: '#999' }} /> {label}
    </FetchingLabel>
  );
}
